<template>
  <!-- 手动铺剧 -->
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 -->
      <div class="search-card">
        <el-form inline :model="searchForm">
          <el-form-item label="短剧名称(精准):">
            <el-input placeholder="每行一个精准短剧名称，敲击回车换行" :rows="3" type="textarea" v-model="desc"
              @change="handleInputChange" style="width: 260px"></el-input>
          </el-form-item>
          <el-form-item label="平台编码:">
            <el-select v-model="platformCode" clearable placeholder="请选择平台编码" size="mini" style="width: 200px">
              <el-option v-for="item in platformList" :key="item.platformCode" :label="item.platformName"
                :value="item.platformCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="短剧ID:">
            <el-input v-model="platformDramaId" placeholder="请精准输入短剧ID" clearable size="mini"
              style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="短剧名称(单个):">
            <el-input v-model="name" placeholder="可模糊查询" clearable size="mini" style="width: 200px"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="success" size="mini" @click="booklistSearchFun()">搜索</el-button>
            <el-button size="mini" @click="booklistResetFun()">重置</el-button>
          </el-form-item>
        </el-form>

        <!-- 搜索提示 -->
        <div class="search-tip">
          <el-icon class="search-tip-icon">
            <WarningFilled />
          </el-icon>
          <span>如果短剧不存在，请前往全域剧目管理添加短剧</span>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <!-- 工具栏 -->
        <div class="table-toolbar">
          <el-button type="primary" size="small" @click="manualPlayletBatchFun">手动铺剧<span v-if="selectRows.length">（{{
            selectRows.length }}）</span></el-button>
          <el-button type="primary" size="small" plain @click="openPlayletLogFun">铺剧日志</el-button>
          <el-button type="primary" size="small" icon="el-icon-folder-opened" @click="openGlobalTemplatePage">
            模板管理
          </el-button>
        </div>

        <el-table ref="tableRef" :data="tableData" border stripe v-loading="loading" style="width: 100%"
          empty-text="请输入短剧名称再搜索数据" @selection-change="onSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column prop="name" label="短剧名称" min-width="220" show-overflow-tooltip> </el-table-column>
          <el-table-column prop="type" label="类型"> </el-table-column>
          <el-table-column prop="platformDramaId" label="短剧ID" width="200"> </el-table-column>
          <el-table-column prop="playletId" label="专辑ID" width="200"> </el-table-column>
          <el-table-column prop="estimatePublishTime" label="预估投放时间" width="160"> </el-table-column>
          <el-table-column prop="totalEpisode" label="总集数" width="80"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrap">
          <paginationMax50 @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
            :total="total" :pagesize="pagesize" :currentPage="currentPage"></paginationMax50>
        </div>
      </div>
    </div>

    <!-- 手动铺剧弹窗 -->
    <el-dialog v-model="manualPlayletView" width="760px" append-to-body destroy-on-close
      custom-class="manual-playlet-dialog">
      <template #title>
        <div class="manual-dialog-header">
          <div class="manual-dialog-title-wrap">
            <span class="manual-dialog-icon">铺</span>
            <div>
              <div class="manual-dialog-title">手动铺剧</div>
              <div class="manual-dialog-subtitle">配置投放账户与执行参数，快速创建铺剧任务</div>
            </div>
          </div>
          <div class="manual-dialog-count">已选 {{ selectRows.length }} 部</div>
        </div>
      </template>
      <div class="manual-dialog-body">
        <el-alert type="info" :closable="false" show-icon class="manual-playlet-tip"
          title="ROI、项目预算和素材条数默认读取模板配置，也可以在下方按本次任务单独调整" />
        <div class="manual-section">
          <div class="manual-section-heading"><span class="section-index">01</span><span>投放对象</span><span
              class="section-line"></span></div>
          <div class="selected-drama-card">
            <div class="selected-drama-card-head"><span>已选短剧</span><span class="selected-drama-count">{{
              selectRows.length }}
                部</span></div>
            <div class="selected-drama-list">
              <el-tag v-for="item in selectRows" :key="item.platformDramaId || item.id" size="small"
                class="selected-drama-tag">
                {{ item.name }}
              </el-tag>
              <span v-if="selectRows.length === 0" class="selected-drama-empty">未选择短剧</span>
            </div>
          </div>
        </div>
        <div class="manual-section">
          <div class="manual-section-heading"><span class="section-index">02</span><span>账户与抖音号</span><span
              class="section-line"></span></div>
          <el-form label-width="92px" label-suffix=":" class="manual-playlet-form">
            <el-form-item label="媒体账户">
              <div class="account-select-box">
                <div class="account-select-content">
                  <template v-if="config.mediaAccountList.length > 0">
                    <el-tooltip :content="mediaAccountNames" placement="top" :show-after="200">
                      <span class="account-names">{{ mediaAccountNames }}</span>
                    </el-tooltip>
                    <span class="account-count">{{ config.mediaAccountList.length }} 个</span>
                  </template>
                  <span v-else class="account-placeholder">请选择媒体账户</span>
                </div>
                <el-button type="primary" size="small" plain @click="mediaAccountView = true">选择账户</el-button>
              </div>
            </el-form-item>
            <el-form-item label="抖音号分配">
              <div class="douyin-assignment">
                <el-button type="warning" size="small" :disabled="config.accountIds.length === 0"
                  @click="openAccountDouyinFun">选择抖音号</el-button>
                <span class="account-count">已配置 {{ configuredAccountCount }}/{{ config.accountIds.length }} 个账户</span>
                <el-button type="text" size="small" :disabled="accountDouyinMap.length === 0"
                  @click="clearAccountDouyinFun">清空</el-button>
              </div>
              <div v-if="config.accountIds.length === 0" class="field-tip">请先选择媒体账户，再为每个账户指定抖音号</div>
            </el-form-item>
          </el-form>
        </div>
        <div class="manual-section manual-parameter-section">
          <div class="manual-section-heading"><span class="section-index">03</span><span>执行参数</span><span
              class="section-line"></span><span class="section-heading-tip">模板可在《模板管理》新建</span></div>
          <el-form label-width="92px" label-suffix=":" class="manual-playlet-form">
            <el-form-item label="模板">
              <el-select v-model="config.templateId" placeholder="请选择模板" clearable filterable style="width: 100%"
                @visible-change="onTemplateVisibleChange" @change="onTemplateChangeFun">
                <el-option v-for="item in templateOptions" :key="item.id" :label="item.templateName" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="出价策略">
              <el-radio-group v-model="config.bidStrategy">
                <el-radio-button label="FIXED">固定</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div class="parameter-grid">
              <el-form-item label="ROI 目标">
                <div class="roi-field">
                  <el-input-number v-model="config.uniRoiGoal" :min="0.0001" :max="5" :precision="4" :step="0.1"
                    :controls="false" placeholder="跟随模板" style="width: 100%" />
                  <span class="field-tip">0.0001~5，最多 4 位小数</span>
                </div>
              </el-form-item>
              <el-form-item label="项目预算">
                <div class="budget-field">
                  <el-input-number v-model="config.budget" :min="0" :precision="2" :step="100" :controls="false"
                    placeholder="跟随模板" style="width: 100%" />
                  <span class="budget-unit">元</span>
                </div>
              </el-form-item>
              <el-form-item label="素材条数">
                <el-input-number v-model="config.materialSelectCount" :min="0" :max="200" :precision="0" :step="1"
                  :controls="false" placeholder="跟随模板" style="width: 100%" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <template #footer>
        <div class="manual-dialog-footer">
          <span class="manual-footer-tip">提交后将按当前配置创建铺剧任务</span>
          <div><el-button @click="manualPlayletView = false">取消</el-button>
            <el-button type="primary" :loading="manualPlayletSubmitting"
              @click="manualPlayletConfirmFun">确认铺剧</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <!-- 选择媒体账户弹窗 -->
    <el-dialog v-model="mediaAccountView" title="选择媒体账户" width="40%" append-to-body destroy-on-close>
      <insertViewBatchTrim @getDataListFun="getSonAccountListFun" :datas="config.accountIds"
        :descParam="config.accountIdsDesc" @getCannelFun="mediaAccountView = false"></insertViewBatchTrim>
    </el-dialog>

    <!-- 分账户指定抖音号弹窗 -->
    <el-dialog v-model="accountDouyinView" title="分账户指定抖音号" width="70%" append-to-body destroy-on-close>
      <el-table :data="accountDouyinMap" border style="width: 100%" empty-text="请先选择账户">
        <el-table-column label="账户" min-width="240">
          <template #default="scope">
            <div class="account-cell-name">{{ getAccountNameById(scope.row.accountId) }}</div>
            <div class="account-cell-id">ID：{{ scope.row.accountId }}</div>
          </template>
        </el-table-column>
        <el-table-column label="已选抖音号" min-width="320">
          <template #default="scope">
            <el-select :model-value="scope.row.douyinIds"
              @update:model-value="(val) => onAccountDouyinChange(scope.row.accountId, val)" multiple filterable
              clearable placeholder="请选择抖音号" size="small" style="width: 100%"
              :loading="!!awemeLoadingMap[scope.row.accountId]"
              @visible-change="(v) => onAwemeVisibleChange(v, scope.row)">
              <el-option v-for="item in (awemeOptionsMap[scope.row.accountId] || scope.row.douyinOptions || [])"
                :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="90" align="center">
          <template #default="scope">
            <span class="num-blue">{{ (scope.row.douyinIds || []).length }}</span>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button @click="accountDouyinView = false">取消</el-button>
        <el-button type="primary" @click="confirmAccountDouyinFun">确定</el-button>
      </template>
    </el-dialog>

    <!-- 手动铺剧提交结果弹窗 -->
    <el-dialog v-model="manualPlayletResultView" title="提交成功" width="520px" append-to-body destroy-on-close>
      <el-descriptions :column="1" border size="small">
        <el-descriptions-item label="批次号">{{ manualPlayletResult.runNo || '-' }}</el-descriptions-item>
        <el-descriptions-item label="剧目数">{{ manualPlayletResult.dramaCount ?? 0 }}</el-descriptions-item>
        <el-descriptions-item label="任务数">{{ manualPlayletResult.itemCount ?? 0 }}</el-descriptions-item>
        <el-descriptions-item label="商品任务数">{{ manualPlayletResult.productTaskCount ?? 0 }}</el-descriptions-item>
        <el-descriptions-item label="素材匹配任务数">{{ manualPlayletResult.matchTaskCount ?? 0 }}</el-descriptions-item>
        <el-descriptions-item label="打链排队数">{{ manualPlayletResult.linkQueued ?? 0 }}</el-descriptions-item>
      </el-descriptions>
      <div v-if="manualPlayletResult.skipped && manualPlayletResult.skipped.length > 0" class="skipped-box">
        <div class="skipped-title">跳过剧目：</div>
        <div v-for="(item, index) in manualPlayletResult.skipped" :key="index" class="skipped-item">
          {{ formatSkippedItem(item) }}
        </div>
      </div>
      <template #footer>
        <el-button type="primary" @click="manualPlayletResultView = false">知道了</el-button>
      </template>
    </el-dialog>

    <!-- 铺剧日志弹窗 -->
    <el-dialog v-model="playletLogView" title="铺剧日志" width="80%" append-to-body destroy-on-close>
      <div class="log-toolbar">
        <span class="log-toolbar-label">状态：</span>
        <el-select v-model="playletLogStatus" placeholder="请选择状态" clearable size="small" style="width: 180px">
          <el-option v-for="item in playletLogStatusOptions" :key="item.value" :label="item.label"
            :value="item.value" />
        </el-select>
        <el-button type="primary" size="small" @click="playletLogSearchFun">搜索</el-button>
        <el-button size="small" @click="playletLogResetFun">重置</el-button>
      </div>
      <el-table :data="playletLogData" border stripe v-loading="playletLogLoading" style="width: 100%"
        empty-text="暂无铺剧日志">
        <el-table-column label="操作" width="140" fixed="left">
          <template #default="scope">
            <el-button type="text" size="mini" @click="openPlayletLogDetailFun(scope.row)">详情</el-button>
            <el-button type="text" size="mini" @click="playletLogRetryFun(scope.row)">重试</el-button>
            <el-button type="text" size="mini" class="danger-text" @click="playletLogStopFun(scope.row)">停止</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="runNo" label="批次号" min-width="190" show-overflow-tooltip />
        <el-table-column prop="templateName" label="模板名称" min-width="160" show-overflow-tooltip />
        <el-table-column label="状态" width="100">
          <template #default="scope">
            <el-tag size="mini" :type="playletLogStatusTagType(scope.row.status)">{{
              playletLogStatusText(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="uniRoiGoal" label="ROI" width="90" />
        <el-table-column prop="budget" label="项目预算" width="100" />
        <el-table-column prop="materialSelectCount" label="素材选取条数" width="120" />
        <el-table-column label="产品类型" width="100">
          <template #default="scope">{{ playletLogProductTypeText(scope.row.productType) }}</template>
        </el-table-column>
        <el-table-column prop="createByName" label="创建人" width="110" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column prop="dramaCount" label="剧目数" width="80" />
        <el-table-column prop="itemCount" label="槽位数" width="80" />
        <el-table-column label="链接成功剧数" width="120">
          <template #default="scope"><span :class="playletLogSuccessClass(scope.row.linkSuccess)">{{
            scope.row.linkSuccess }}</span></template>
        </el-table-column>
        <el-table-column label="链接失败剧数" width="120">
          <template #default="scope"><span :class="playletLogFailClass(scope.row.linkFail)">{{ scope.row.linkFail
          }}</span></template>
        </el-table-column>
        <el-table-column prop="linkWaiting" label="链接待投放剧数" width="140" />
        <el-table-column prop="linkCreating" label="链接建链中剧数" width="140" />
        <el-table-column label="商品成功剧数" width="120">
          <template #default="scope"><span :class="playletLogSuccessClass(scope.row.productSuccess)">{{
            scope.row.productSuccess }}</span></template>
        </el-table-column>
        <el-table-column label="商品失败剧数" width="120">
          <template #default="scope"><span :class="playletLogFailClass(scope.row.productFail)">{{ scope.row.productFail
          }}</span></template>
        </el-table-column>
        <el-table-column label="素材匹配成功剧数" width="140">
          <template #default="scope"><span :class="playletLogSuccessClass(scope.row.matchSuccess)">{{
            scope.row.matchSuccess }}</span></template>
        </el-table-column>
        <el-table-column label="素材匹配失败剧数" width="140">
          <template #default="scope"><span :class="playletLogFailClass(scope.row.matchFail)">{{ scope.row.matchFail
          }}</span></template>
        </el-table-column>
        <el-table-column label="项目成功槽位数" width="130">
          <template #default="scope"><span :class="playletLogSuccessClass(scope.row.projectSuccess)">{{
            scope.row.projectSuccess }}</span></template>
        </el-table-column>
        <el-table-column label="项目失败槽位数" width="130">
          <template #default="scope"><span :class="playletLogFailClass(scope.row.projectFail)">{{ scope.row.projectFail
          }}</span></template>
        </el-table-column>
        <el-table-column prop="projectWaiting" label="待投放槽位数" width="120" />
      </el-table>
      <div class="pagination-wrap">
        <paginationMax100 @handleSizeChange="handlePlayletLogSizeChange"
          @handleCurrentChange="handlePlayletLogCurrentChange" :total="playletLogTotal" :pagesize="playletLogPagesize"
          :currentPage="playletLogCurrentPage"></paginationMax100>
      </div>
    </el-dialog>

    <!-- 铺剧批次详情弹窗 -->
    <el-dialog v-model="playletLogDetailView" title="铺剧详情" width="85%" append-to-body destroy-on-close>
      <div v-loading="playletLogDetailLoading" class="log-detail-box">
        <!-- 批次信息 -->
        <el-descriptions :column="3" border size="small" class="detail-descriptions">
          <el-descriptions-item label="批次号">{{ playletLogDetailRun.runNo || '-' }}</el-descriptions-item>
          <el-descriptions-item label="模板名称">{{ playletLogDetailRun.templateName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag size="mini" :type="playletLogStatusTagType(playletLogDetailRun.status)">
              {{ playletLogStatusText(playletLogDetailRun.status) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="ROI">{{ playletLogDetailRun.uniRoiGoal ?? '-' }}</el-descriptions-item>
          <el-descriptions-item label="项目预算">{{ playletLogDetailRun.budget ?? '-' }} 元</el-descriptions-item>
          <el-descriptions-item label="素材选取条数">{{ playletLogDetailRun.materialSelectCount ?? '-'
          }}</el-descriptions-item>
          <el-descriptions-item label="产品类型">{{ playletLogProductTypeText(playletLogDetailRun.productType)
          }}</el-descriptions-item>
          <el-descriptions-item label="出价策略">{{ playletLogDetailRun.bidStrategy || '-' }}</el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ playletLogDetailRun.createTime || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 批次统计 -->
        <div class="detail-summary">
          <span>剧目 <b>{{ playletLogDetailRun.dramaCount ?? 0 }}</b></span>
          <span>槽位 <b>{{ playletLogDetailRun.itemCount ?? 0 }}</b></span>
          <span>商品成功 <b class="success-text">{{ playletLogDetailRun.productSuccess ?? 0 }}</b> / 失败 <b
              class="fail-text">{{
                playletLogDetailRun.productFail ?? 0 }}</b> / 其他 <b class="waiting-text">{{
                playletDetailOtherCount('product') }}</b></span>
          <span>链接成功 <b class="success-text">{{ playletLogDetailRun.linkSuccess ?? 0 }}</b> / 失败 <b class="fail-text">{{
            playletLogDetailRun.linkFail ?? 0 }}</b> / 其他 <b class="waiting-text">{{
                playletDetailOtherCount('link') }}</b></span>
          <span>匹配成功 <b class="success-text">{{ playletLogDetailRun.matchSuccess ?? 0 }}</b> / 失败 <b
              class="fail-text">{{
                playletLogDetailRun.matchFail ?? 0 }}</b> / 其他 <b class="waiting-text">{{
                playletDetailOtherCount('match') }}</b></span>
          <span>项目成功 <b class="success-text">{{ playletLogDetailRun.projectSuccess ?? 0 }}</b> / 失败 <b
              class="fail-text">{{
                playletLogDetailRun.projectFail ?? 0 }}</b> / 其他 <b class="waiting-text">{{
                playletDetailOtherCount('project') }}</b></span>
        </div>

        <!-- 批次级重试 -->
        <div class="detail-toolbar">
          <el-button type="warning" size="small" @click="retryRunStepFun('PRODUCT')">重试商品</el-button>
          <el-button type="warning" size="small" @click="retryRunStepFun('LINK')">重试链接</el-button>
          <el-button type="warning" size="small" @click="retryRunStepFun('MATCH')">重试素材匹配</el-button>
          <el-button type="warning" size="small" @click="retryRunStepFun('PROJECT')">重试项目</el-button>
          <span class="detail-toolbar-tip">批次级重试会处理该批次所有失败剧</span>
        </div>

        <!-- 剧目明细 -->
        <div class="detail-section-title">剧目明细</div>
        <el-table :data="playletLogDetail.dramas || []" border size="small" empty-text="暂无剧目数据">
          <el-table-column prop="dramaName" label="短剧名称" min-width="200" show-overflow-tooltip />
          <el-table-column prop="platformDramaId" label="短剧ID" width="180" show-overflow-tooltip />
          <el-table-column prop="playletId" label="专辑ID" width="180" show-overflow-tooltip />
          <el-table-column label="商品状态" width="100">
            <template #default="scope">
              <el-tag size="mini" :type="dramaStatusInfo(scope.row.productStatus, 'product').tagType">
                {{ dramaStatusInfo(scope.row.productStatus, 'product').text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="链接状态" width="100">
            <template #default="scope">
              <el-tag size="mini" :type="dramaStatusInfo(scope.row.linkStatus, 'link').tagType">
                {{ dramaStatusInfo(scope.row.linkStatus, 'link').text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="素材匹配状态" width="110">
            <template #default="scope">
              <el-tag size="mini" :type="dramaStatusInfo(scope.row.matchStatus, 'match').tagType">
                {{ dramaStatusInfo(scope.row.matchStatus, 'match').text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="最后检测" width="110">
            <template #default="scope">
              <el-tag size="mini" :type="dramaStatusInfo(scope.row.finalCheckStatus, 'finalCheck').tagType">
                {{ dramaStatusInfo(scope.row.finalCheckStatus, 'finalCheck').text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="errorMsg" label="错误信息" min-width="180" show-overflow-tooltip />
          <el-table-column label="操作" width="100" fixed="right">
            <template #default="scope">
              <el-button type="text" size="mini" @click="retryDramaStepFun(scope.row, 'LINK')">重试链接</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 槽位明细 -->
        <div class="detail-section-title">槽位明细</div>
        <el-table :data="playletLogDetail.items || []" border size="small" empty-text="暂无槽位数据">
          <el-table-column label="关联短剧" min-width="160" show-overflow-tooltip>
            <template #default="scope">{{ playletLogDetailDramaNameMap[scope.row.dramaRowId] || '-' }}</template>
          </el-table-column>
          <el-table-column prop="advertiserId" label="账户ID" width="180" show-overflow-tooltip />
          <el-table-column prop="awemeId" label="抖音号ID" width="160" show-overflow-tooltip />
          <el-table-column label="项目状态" width="110">
            <template #default="scope">
              <el-tag size="mini" :type="itemStatusInfo(scope.row.status).tagType">
                {{ itemStatusInfo(scope.row.status).text }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="retryCount" label="重试次数" width="90" />
          <el-table-column prop="errorMsg" label="错误信息" min-width="220" show-overflow-tooltip />
          <el-table-column label="操作" width="100" fixed="right">
            <template #default="scope">
              <el-button type="text" size="mini" @click="retryItemStepFun(scope.row)">重试项目</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <el-button type="primary" @click="playletLogDetailView = false">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { booklist, bookplatformList, globalAdConfigcheckAccounts, teamsharecheckAccounts, templateRunpage, globalTemplatePage, globalAdConfigaAwemeAuthList, templateRunsubmit, templateRundetail, templateRunretry, templateRunstop } from '@/request/new/ylyBatch'
import { ElMessage, ElMessageBox } from 'element-plus'
import { WarningFilled } from '@element-plus/icons-vue'
import { computed, reactive, toRefs, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import paginationMax50 from '@/components/paginationMax50.vue' // 主列表分页（最多50条/页）
import paginationMax100 from '@/components/paginationMax100.vue' // 铺剧日志分页（最多100条/页）
import insertViewBatchTrim from '@/components/batch/insertViewBatchTrim.vue'

export default {
  name: 'ylyPlayletBatchManage',
  components: { paginationMax50, paginationMax100, WarningFilled, insertViewBatchTrim },
  setup() {
    const router = useRouter()

    // 模板管理：新开页签跳转全局模板页面
    const openGlobalTemplatePage = () => {
      const routeData = router.resolve({ path: '/ylyGlobalTemplate' })
      window.open(routeData.href, '_blank')
    }

    // 手动铺剧：需先勾选短剧，再打开弹窗
    const manualPlayletBatchFun = () => {
      if (state.selectRows.length === 0) {
        return ElMessage.warning('请先勾选需要铺剧的短剧数据')
      }
      state.manualPlayletView = true
    }

    const tableRef = ref(null)
    const state = reactive({
      // 平台编码（精确）
      platformCode: '',
      // 平台短剧ID（精确）
      platformDramaId: '',
      // 短剧名称（模糊、单个）
      name: '',
      // 批量精准短剧名称的输入原始文本
      desc: '',
      // 批量精准短剧名称数组
      names: [],
      // 平台下拉数据
      platformList: [],
      // 表格数据
      tableData: [],
      // 表格 loading
      loading: false,
      // 多选勾选的行
      selectRows: [],
      // 多选勾选行变化
      onSelectionChange: (val) => {
        state.selectRows = val || []
      },
      // 清空多选
      clearSelectionFun: () => {
        tableRef.value?.clearSelection()
      },
      // 手动铺剧弹窗
      manualPlayletView: false,
      // 手动铺剧提交中
      manualPlayletSubmitting: false,
      // 手动铺剧提交结果弹窗
      manualPlayletResultView: false,
      // 手动铺剧提交结果
      manualPlayletResult: {},
      // 铺剧日志弹窗
      playletLogView: false,
      // 铺剧日志状态筛选
      playletLogStatus: '',
      // 铺剧日志状态下拉
      playletLogStatusOptions: [
        { label: '待执行', value: 0 },
        { label: '执行中', value: 1 },
        { label: '完成', value: 2 },
        { label: '部分失败', value: 3 },
        { label: '已停止', value: 4 },
      ],
      // 铺剧日志当前页数据
      playletLogData: [],
      // 铺剧日志 loading
      playletLogLoading: false,
      // 铺剧日志 条数
      playletLogPagesize: 20,
      // 铺剧日志 当前页数
      playletLogCurrentPage: 1,
      // 铺剧日志 总数
      playletLogTotal: 0,
      // 铺剧日志详情弹窗
      playletLogDetailView: false,
      // 铺剧日志详情 loading
      playletLogDetailLoading: false,
      // 铺剧日志详情数据
      playletLogDetail: {},
      // 铺剧日志详情对应的批次ID
      playletLogDetailRunId: '',
      // 选择媒体账户弹窗
      mediaAccountView: false,
      // 手动铺剧表单
      config: {
        accountIds: [],
        accountIdsDesc: '',
        mediaAccountList: [],
        douyinSelectType: 1,
        templateId: '',
        productType: 'GLOBAL',
        bidStrategy: 'FIXED',
        uniRoiGoal: null,
        budget: null,
        materialSelectCount: null,
      },
      // 模板下拉数据
      templateOptions: [],
      // 模板下拉是否已加载（点击选择器时懒加载）
      templateOptionsLoaded: false,
      // 分账户指定抖音号：{ accountId, douyinIds, douyinOptions, douyinNameMap }
      accountDouyinMap: [],
      // 分账户指定弹窗
      accountDouyinView: false,
      // 按账户缓存的抖音号选项
      awemeOptionsMap: {},
      // 按账户缓存的抖音号加载状态
      awemeLoadingMap: {},
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 0,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        booklistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        state.currentPage = 1
        booklistFun()
      },
      // 监听把输入的数据变成短剧名称数组
      handleInputChange: () => {
        state.names = parseNames()
      },
      // 搜索：回到第一页再查
      booklistSearchFun: () => {
        state.currentPage = 1
        booklistFun()
      },
      // 重置筛选条件
      booklistResetFun: () => {
        state.platformCode = ''
        state.platformDramaId = ''
        state.name = ''
        state.desc = ''
        state.names = []
        state.currentPage = 1
        state.tableData = []
        state.total = 0
        ElMessage.info('已重置筛选条件，请输入短剧名称(精准)、短剧名称(单个)或短剧ID后再搜索')
      },
    })

    const loginUserName = localStorage.getItem('userName')

    // 已选媒体账户名称拼接（用于省略展示）
    const mediaAccountNames = computed(() => {
      return state.config.mediaAccountList
        .map((item) => item.name || item.accountName || item.douyinName || item.id)
        .join('、')
    })

    // 接收媒体账户组件返回的数据：先校验账户，再校验授权
    const getSonAccountListFun = (data) => {
      globalAdConfigcheckAccounts(data.dataList).then((res) => {
        if (res.code != 200) return
        // 管理员不走账户授权校验
        if (loginUserName == '黄彬' || loginUserName == '任文龙') {
          applyAccountData(data, res.data)
          return
        }
        teamsharecheckAccounts({ accountIds: data.dataList }).then((authRes) => {
          if (authRes.code != 200) return
          const noAuthList = (authRes.data || []).filter((item) => !item.allowed)
          if (noAuthList.length > 0) {
            const errMsg = noAuthList
              .map((item) => `组织名称：${item.teamName}<br/>账户名称：${item.accountName}<br/>账户id：${item.accountId}<br/>未授权请找组长授权`)
              .join('<br/><br/>')
            return ElMessage.error({ dangerouslyUseHTMLString: true, message: errMsg })
          }
          applyAccountData(data, res.data)
        })
      })
    }

    const applyAccountData = (data, list) => {
      state.config.accountIds = data.dataList
      state.config.accountIdsDesc = data.desc
      state.config.mediaAccountList = list || []
      state.config.accountIds = Array.isArray(state.config.accountIds) ? state.config.accountIds : []
      syncAccountDouyinRows()
      state.mediaAccountView = false
    }

    const syncAccountDouyinRows = () => {
      const oldRows = state.accountDouyinMap || []
      state.accountDouyinMap = (state.config.accountIds || []).map((accountId) => {
        const existing = oldRows.find((row) => String(row.accountId) === String(accountId))
        return {
          accountId,
          douyinIds: existing && Array.isArray(existing.douyinIds) ? existing.douyinIds : [],
          douyinOptions: existing && Array.isArray(existing.douyinOptions) ? existing.douyinOptions : [],
          douyinNameMap: existing && existing.douyinNameMap ? existing.douyinNameMap : {},
        }
      })
    }

    watch(() => state.config.accountIds, syncAccountDouyinRows, { deep: true })

    const fetchAllAwemeAuthList = async (advertiserId) => {
      const pageSize = 100
      const firstRes = await globalAdConfigaAwemeAuthList({ advertiserId, page: 1, pageSize })
      if (!firstRes || firstRes.code !== 200) throw new Error((firstRes && firstRes.msg) || '抖音号授权列表加载失败')
      const firstData = firstRes.data || {}
      const firstList = Array.isArray(firstData.list) ? firstData.list : []
      const totalPage = Number(firstData.page_info && firstData.page_info.total_page) || 1
      if (totalPage <= 1) return firstList
      const pageResults = await Promise.all(
        Array.from({ length: totalPage - 1 }, (_, index) =>
          globalAdConfigaAwemeAuthList({ advertiserId, page: index + 2, pageSize })
        )
      )
      return firstList.concat(...pageResults.map((res) => {
        if (!res || res.code !== 200) throw new Error((res && res.msg) || '抖音号授权列表加载失败')
        return Array.isArray(res.data && res.data.list) ? res.data.list : []
      }))
    }

    const getAccountNameById = (accountId) => {
      const account = (state.config.mediaAccountList || []).find((item) =>
        String(item.accountId ?? item.id ?? item.douyinId) === String(accountId)
      )
      return account ? account.name || account.accountName || account.douyinName || `账户 ${accountId}` : `账户 ${accountId}`
    }

    const openAccountDouyinFun = () => {
      if (!state.config.accountIds.length) return ElMessage.warning('请先选择媒体账户')
      syncAccountDouyinRows()
      state.accountDouyinView = true
    }

    const onAwemeVisibleChange = (visible, row) => {
      if (!visible || !row) return
      const accountId = row.accountId
      state.awemeLoadingMap[accountId] = true
      fetchAllAwemeAuthList(accountId).then((list) => {
        state.awemeOptionsMap[accountId] = list.map((item) => ({
          label: item.aweme_name,
          value: item.aweme_id,
        }))
        row.douyinOptions = state.awemeOptionsMap[accountId]
      }).catch(() => {
        ElMessage.error('抖音号授权列表加载失败')
      }).finally(() => {
        state.awemeLoadingMap[accountId] = false
      })
    }

    const onAccountDouyinChange = (accountId, douyinIds) => {
      const row = state.accountDouyinMap.find((item) => String(item.accountId) === String(accountId))
      if (row) row.douyinIds = douyinIds || []
    }

    const clearAccountDouyinFun = () => {
      state.accountDouyinMap.forEach((row) => { row.douyinIds = [] })
    }

    const confirmAccountDouyinFun = () => {
      state.accountDouyinView = false
    }

    const configuredAccountCount = computed(() =>
      state.accountDouyinMap.filter((row) => (row.douyinIds || []).length > 0).length
    )

    // 查询当前登录人的模板下拉：按分页把所有数据合并回来
    const globalTemplateOptionsFun = () => {
      const pageSize = 100
      globalTemplatePage({ currentPage: 1, size: pageSize }).then((firstRes) => {
        if (firstRes.code != 200 && firstRes.code != 0) {
          state.templateOptionsLoaded = false
          return
        }
        const firstPage = firstRes.data || {}
        const firstList = Array.isArray(firstPage.data) ? firstPage.data : []
        const total = Number(firstPage.totalSize) || firstList.length
        const totalPage = Math.ceil(total / pageSize)
        if (totalPage <= 1) {
          state.templateOptions = firstList
          return
        }
        const pageRequests = Array.from({ length: totalPage - 1 }, (_, index) =>
          globalTemplatePage({ currentPage: index + 2, size: pageSize })
        )
        Promise.all(pageRequests).then((results) => {
          const restList = results.flatMap((res) => {
            const page = res && res.data ? res.data : {}
            return Array.isArray(page.data) ? page.data : []
          })
          state.templateOptions = firstList.concat(restList)
        }).catch(() => {
          state.templateOptions = firstList
        })
      }).catch(() => {
        state.templateOptionsLoaded = false
      })
    }

    // 点击模板选择器时懒加载模板数据
    const onTemplateVisibleChange = (visible) => {
      if (!visible || state.templateOptionsLoaded) return
      state.templateOptionsLoaded = true
      globalTemplateOptionsFun()
    }

    // 选择模板后带出模板对应的 ROI / 预算 / 素材选取条数
    const onTemplateChangeFun = (templateId) => {
      const template = state.templateOptions.find((item) => String(item.id) === String(templateId))
      if (!template) {
        state.config.uniRoiGoal = null
        state.config.budget = null
        state.config.materialSelectCount = null
        return
      }
      state.config.uniRoiGoal = template.uniRoiGoal == null ? null : Number(template.uniRoiGoal)
      state.config.budget = template.budget == null ? null : Number(template.budget)
      state.config.materialSelectCount = template.materialSelectCount == null ? null : Number(template.materialSelectCount)
    }

    // 手动铺剧确定：调用模板执行提交
    const manualPlayletConfirmFun = () => {
      if (state.selectRows.length === 0) {
        return ElMessage.warning('请先勾选需要铺剧的短剧数据')
      }
      if (!state.config.templateId) {
        return ElMessage.warning('请选择模板')
      }
      if (state.config.accountIds.length === 0) {
        return ElMessage.warning('请选择账户')
      }
      const missingAccount = state.accountDouyinMap.find((row) => !(row.douyinIds || []).length)
      if (missingAccount) {
        return ElMessage.warning(`请为账户 ${getAccountNameById(missingAccount.accountId)} 指定至少一个抖音号`)
      }
      const roiFilled = state.config.uniRoiGoal !== null && state.config.uniRoiGoal !== undefined && state.config.uniRoiGoal !== ''
      const uniRoiGoal = roiFilled ? Number(state.config.uniRoiGoal) : null
      if (roiFilled && (!uniRoiGoal || uniRoiGoal < 0.0001 || uniRoiGoal > 5)) {
        return ElMessage.warning('全域 ROI 目标取值范围 0.0001~5')
      }
      const materialFilled = state.config.materialSelectCount !== null && state.config.materialSelectCount !== undefined && state.config.materialSelectCount !== ''
      if (materialFilled && (Number(state.config.materialSelectCount) < 0 || Number(state.config.materialSelectCount) > 200)) {
        return ElMessage.warning('素材条数取值范围 0~200')
      }
      if (state.manualPlayletSubmitting) return

      // 组装账户-抖音号绑定，并补充 douyinId -> 抖音号名称 映射
      const accountDouyinMap = state.accountDouyinMap.map((row) => {
        const douyinNameMap = {}
        const options = state.awemeOptionsMap[row.accountId] || row.douyinOptions || []
        options.forEach((item) => {
          if (item && item.value != null && item.value !== '' && item.label != null) {
            douyinNameMap[item.value] = item.label
          }
        })
          ; (row.douyinIds || []).forEach((id) => {
            if (douyinNameMap[id] == null && row.douyinNameMap && row.douyinNameMap[id] != null) {
              douyinNameMap[id] = row.douyinNameMap[id]
            }
          })
        return {
          accountId: Number(row.accountId),
          douyinIds: (row.douyinIds || []).map((id) => String(id)),
          douyinNameMap,
        }
      })

      const payload = {
        templateId: Number(state.config.templateId),
        dramaIds: state.selectRows
          .map((row) => (row.platformDramaId == null ? '' : String(row.platformDramaId)))
          .filter((item) => item !== ''),
        accountDouyinMap,
        productType: state.config.productType,
        bidStrategy: state.config.bidStrategy,
      }
      // 以下三项可选填，不填不传，使用模板对应配置
      if (roiFilled) payload.uniRoiGoal = uniRoiGoal
      if (state.config.budget !== null && state.config.budget !== undefined && state.config.budget !== '') {
        payload.budget = Number(state.config.budget)
      }
      if (state.config.materialSelectCount !== null && state.config.materialSelectCount !== undefined && state.config.materialSelectCount !== '') {
        payload.materialSelectCount = Number(state.config.materialSelectCount)
      }

      state.manualPlayletSubmitting = true
      templateRunsubmit(payload)
        .then((res) => {
          if (res.code == 200 || res.code == 0) {
            state.manualPlayletResult = res.data || {}
            if (state.playletLogView) playletLogPageFun()
            state.manualPlayletView = false
            state.manualPlayletResultView = true
            tableRef.value?.clearSelection()
            state.selectRows = []
          } else {
            ElMessage.error(res.msg || res.message || '提交失败')
          }
        })
        .catch(() => {
          ElMessage.error('提交失败')
        })
        .finally(() => {
          state.manualPlayletSubmitting = false
        })
    }

    // 跳过剧目展示文案
    const formatSkippedItem = (item) => {
      if (item == null) return ''
      if (typeof item === 'string') return item
      const name = item.dramaName || item.name || item.platformDramaId || item.dramaId
      const reason = item.reason || item.msg || item.message
      if (name && reason) return `${name}（${reason}）`
      if (name) return String(name)
      return JSON.stringify(item)
    }

    // 铺剧日志分页查询
    const playletLogPageFun = () => {
      state.playletLogLoading = true
      const datas = {
        currentPage: state.playletLogCurrentPage,
        size: state.playletLogPagesize,
        status: state.playletLogStatus === '' ? undefined : state.playletLogStatus,
      }
      templateRunpage(datas)
        .then((res) => {
          const data = res.data || {}
          state.playletLogCurrentPage = data.currenPage || state.playletLogCurrentPage
          state.playletLogTotal = data.totalSize || 0
          state.playletLogData = Array.isArray(data.data) ? data.data : []
        })
        .finally(() => {
          state.playletLogLoading = false
        })
    }

    // 打开铺剧日志弹窗
    const openPlayletLogFun = () => {
      state.playletLogView = true
      state.playletLogCurrentPage = 1
      playletLogPageFun()
    }

    // 铺剧日志 搜索
    const playletLogSearchFun = () => {
      state.playletLogCurrentPage = 1
      playletLogPageFun()
    }

    // 铺剧日志 重置
    const playletLogResetFun = () => {
      state.playletLogStatus = ''
      state.playletLogCurrentPage = 1
      playletLogPageFun()
    }

    // 铺剧日志 页数发生改变
    const handlePlayletLogCurrentChange = (page) => {
      state.playletLogCurrentPage = page
      playletLogPageFun()
    }

    // 铺剧日志 个数发生改变
    const handlePlayletLogSizeChange = (size) => {
      state.playletLogPagesize = size
      state.playletLogCurrentPage = 1
      playletLogPageFun()
    }

    // 铺剧日志 状态文案
    const playletLogStatusText = (status) => {
      const map = { 0: '待执行', 1: '执行中', 2: '完成', 3: '部分失败', 4: '已停止' }
      return map[status] || ''
    }

    // 铺剧日志 状态标签样式
    const playletLogStatusTagType = (status) => {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger', 4: 'info' }
      return map[status] || ''
    }

    // 铺剧日志 产品类型文案
    const playletLogProductTypeText = (productType) => {
      const map = { GLOBAL: '全域' }
      return map[productType] || productType || ''
    }

    // 铺剧日志 成功/失败数字颜色（0 保持默认黑色）
    const playletLogSuccessClass = (value) => (Number(value) ? 'success-text' : '')
    const playletLogFailClass = (value) => (Number(value) ? 'fail-text' : '')

    // 加载铺剧批次详情
    const loadPlayletLogDetailFun = (runId) => {
      state.playletLogDetailLoading = true
      templateRundetail({ runId })
        .then((res) => {
          state.playletLogDetail = res.data || {}
        })
        .finally(() => {
          state.playletLogDetailLoading = false
        })
    }

    // 铺剧日志详情
    const openPlayletLogDetailFun = (row) => {
      state.playletLogDetailView = true
      state.playletLogDetailRunId = row.id
      state.playletLogDetail = {}
      loadPlayletLogDetailFun(row.id)
    }

    // 重试步骤 → 中文名称
    const retryStepTextMap = {
      PRODUCT: '商品',
      LINK: '链接',
      MATCH: '素材匹配',
      PROJECT: '项目',
    }

    // 根据重试接口返回的 data 组织提示文案（steps / affected / stepCounts）
    const showRetryResult = (res) => {
      const data = (res && res.data) || {}
      const stepCounts = data.stepCounts || {}
      const steps = Array.isArray(data.steps) && data.steps.length ? data.steps : Object.keys(stepCounts)
      const affected = data.affected
      // 各步骤有实际重试数量时展示明细
      const detailLines = steps
        .filter((step) => Number(stepCounts[step]) > 0)
        .map((step) => `${retryStepTextMap[step] || step} ${Number(stepCounts[step])} 条`)
      const affectedText = affected != null ? `本次影响 ${affected} 项` : ''
      if (!detailLines.length) {
        ElMessage.success(affectedText || (res && res.msg) || '已提交重试')
        return
      }
      const html = [`<div>${affectedText || '已提交重试'}</div>`, `<div style="margin-top:4px;color:#909399">${detailLines.join('、')}</div>`].join('')
      ElMessage({
        type: 'success',
        dangerouslyUseHTMLString: true,
        message: html,
        duration: 4000,
      })
    }

    // 批次级重试：商品 / 素材匹配
    const retryRunStepFun = (step) => {
      const runId = state.playletLogDetailRunId
      if (!runId) return
      const stepText = retryStepTextMap[step] || step
      ElMessageBox.confirm(`确定重试该批次所有失败的${stepText}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        templateRunretry({ runId: Number(runId), steps: [step] }).then((res) => {
          showRetryResult(res)
          loadPlayletLogDetailFun(runId)
          if (state.playletLogView) playletLogPageFun()
        })
      }).catch(() => { })
    }

    // 剧目级重试：链接
    const retryDramaStepFun = (row, step) => {
      if (!row || !row.id) return
      ElMessageBox.confirm(`确定重试短剧「${row.dramaName || ''}」的链接吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        templateRunretry({ dramaRowIds: [Number(row.id)], steps: [step] }).then((res) => {
          showRetryResult(res)
          loadPlayletLogDetailFun(state.playletLogDetailRunId)
          if (state.playletLogView) playletLogPageFun()
        })
      }).catch(() => { })
    }

    // 槽位级重试：项目
    const retryItemStepFun = (row) => {
      if (!row || !row.id) return
      ElMessageBox.confirm(`确定重试账户 ${row.advertiserId || ''} / 抖音号 ${row.awemeId || ''} 的项目吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        templateRunretry({ itemIds: [Number(row.id)], steps: ['PROJECT'] }).then((res) => {
          showRetryResult(res)
          loadPlayletLogDetailFun(state.playletLogDetailRunId)
          if (state.playletLogView) playletLogPageFun()
        })
      }).catch(() => { })
    }

    // 剧目级状态文案与颜色
    const dramaStatusInfo = (status, type) => {
      const maps = {
        product: {
          0: ['待执行', 'info'],
          1: ['成功', 'success'],
          2: ['失败', 'danger'],
          3: ['处理中', 'warning'],
        },
        link: {
          0: ['未开始', 'info'],
          1: ['待投放', 'warning'],
          2: ['建链中', 'warning'],
          3: ['成功', 'success'],
          4: ['失败', 'danger'],
        },
        match: { 0: ['待执行', 'info'], 1: ['匹配中', 'warning'], 2: ['成功', 'success'], 3: ['失败', 'danger'] },
        finalCheck: { 0: ['无需/未开始', 'info'], 1: ['进行中', 'warning'], 2: ['成功', 'success'], 3: ['失败', 'danger'] },
      }
      const hit = maps[type] && maps[type][Number(status)]
      return hit ? { text: hit[0], tagType: hit[1] } : { text: status ?? '-', tagType: 'info' }
    }

    // 槽位级项目状态文案与颜色
    const itemStatusInfo = (status) => {
      const map = {
        CREATED: ['已创建，等待前置条件', 'info'],
        READY: ['建项目准备就绪', ''],
        PROJECT_WAITING: ['等待投放时间', 'warning'],
        PROJECT_PENDING: ['待创建项目', 'info'],
        PROJECT_SUCCESS: ['项目创建成功', 'success'],
        PROJECT_FAIL: ['项目创建失败', 'danger'],
      }
      const hit = map[status]
      return hit ? { text: hit[0], tagType: hit[1] } : { text: status || '-', tagType: 'info' }
    }

    // 详情中的批次信息
    const playletLogDetailRun = computed(() => state.playletLogDetail.run || {})

    // 详情统计中的「其他」数量：总数 - 成功 - 失败（商品/链接/匹配按剧目，项目按槽位）
    const playletDetailOtherCount = (type) => {
      const run = playletLogDetailRun.value || {}
      const total = type === 'project' ? Number(run.itemCount) || 0 : Number(run.dramaCount) || 0
      const success = Number(run[`${type}Success`]) || 0
      const fail = Number(run[`${type}Fail`]) || 0
      const other = total - success - fail
      return other > 0 ? other : 0
    }

    // 详情中的剧目行ID -> 短剧名称
    const playletLogDetailDramaNameMap = computed(() => {
      const map = {}
        ; (state.playletLogDetail.dramas || []).forEach((drama) => {
          map[String(drama.id)] = drama.dramaName
        })
      return map
    })

    // 铺剧日志列表「重试」：一键重试该批次全部步骤（商品 / 链接 / 素材匹配 / 项目）
    const PLAYER_LOG_ALL_RETRY_STEPS = ['PRODUCT', 'LINK', 'MATCH', 'PROJECT']
    const playletLogRetryFun = (row) => {
      if (!row || !row.id) return
      ElMessageBox.confirm(`确定一键重试批次「${row.runNo || ''}」的全部步骤（商品、链接、素材匹配、项目）吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        templateRunretry({ runId: Number(row.id), steps: PLAYER_LOG_ALL_RETRY_STEPS }).then((res) => {
          showRetryResult(res)
          playletLogPageFun()
          if (state.playletLogDetailView && state.playletLogDetailRunId === row.id) {
            loadPlayletLogDetailFun(row.id)
          }
        })
      }).catch(() => { })
    }

    // 停止批次
    const playletLogStopFun = (row) => {
      ElMessageBox.confirm(`确定停止批次「${row.runNo || ''}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        templateRunstop({ runId: Number(row.id) }).then((res) => {
          ElMessage.success((res && res.msg) || '已停止')
          playletLogPageFun()
        })
      }).catch(() => { })
    }

    // 解析「短剧名称(精准)」输入框内容为名称数组
    const parseNames = () => {
      return (state.desc || '')
        .split('\n')
        .map((item) => item.trim())
        .filter((item) => item !== '')
    }

    // 分页查询当前登录用户的短剧
    const booklistFun = () => {
      const names = parseNames()
      const name = (state.name || '').trim()
      const platformDramaId = (state.platformDramaId || '').trim()
      // 必须至少满足一个条件：短剧名称(精准)、短剧名称(单个)、短剧ID
      if (names.length === 0 && !name && !platformDramaId) {
        state.loading = false
        state.tableData = []
        state.total = 0
        ElMessage.warning('请至少填写短剧名称(精准)、短剧名称(单个)、短剧ID其中一项后再查询')
        return
      }
      state.loading = true
      const datas = {
        platformCode: state.platformCode,
        platformDramaId,
        name,
        currentPage: state.currentPage,
        size: state.pagesize,
        names,
      }
      booklist(datas)
        .then((res) => {
          const data = res.data || {}
          state.currentPage = data.currenPage
          state.total = data.totalSize
          state.tableData = data.data || []
        })
        .finally(() => {
          state.loading = false
        })
    }

    // 分销平台下拉框（查询所有启用的平台）
    const bookplatformListFun = () => {
      bookplatformList().then((res) => {
        state.platformList = res.data || []
      })
    }

    // 首次进入页面不请求短剧列表，需用户填写查询条件后主动搜索
    bookplatformListFun()

    return {
      ...toRefs(state),
      tableRef,
      booklistFun,
      bookplatformListFun,
      openGlobalTemplatePage,
      manualPlayletBatchFun,
      mediaAccountNames,
      getSonAccountListFun,
      manualPlayletConfirmFun,
      openAccountDouyinFun,
      onAwemeVisibleChange,
      onAccountDouyinChange,
      clearAccountDouyinFun,
      confirmAccountDouyinFun,
      configuredAccountCount,
      getAccountNameById,
      onTemplateVisibleChange,
      onTemplateChangeFun,
      formatSkippedItem,
      openPlayletLogFun,
      handlePlayletLogCurrentChange,
      handlePlayletLogSizeChange,
      playletLogSearchFun,
      playletLogResetFun,
      playletLogStatusText,
      playletLogStatusTagType,
      playletLogProductTypeText,
      playletLogSuccessClass,
      playletLogFailClass,
      openPlayletLogDetailFun,
      playletLogRetryFun,
      playletLogStopFun,
      retryRunStepFun,
      retryDramaStepFun,
      retryItemStepFun,
      dramaStatusInfo,
      itemStatusInfo,
      playletLogDetailRun,
      playletDetailOtherCount,
      playletLogDetailDramaNameMap,
    }
  },
}
</script>

<style lang="scss" scoped>
.page-wrap {
  height: calc(100vh - 70px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
  box-sizing: border-box;
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 表格上方工具栏
.table-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

// 铺剧日志筛选栏
.log-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.log-toolbar-label {
  font-size: 13px;
  color: #606266;
}

.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
}

.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 12px 4px 4px;
  display: flex;
  justify-content: center;
}

.search-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: 13px;
  color: #f56c6c;
  line-height: 1.5;
}

.search-tip-icon {
  font-size: 14px;
  color: #f56c6c;
}

// 手动铺剧弹窗
.manual-dialog-header,
.manual-dialog-title-wrap,
.manual-dialog-footer {
  display: flex;
  align-items: center;
}

.manual-dialog-header {
  justify-content: space-between;
  padding-right: 22px;
}

.manual-dialog-title-wrap {
  gap: 12px;
}

.manual-dialog-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(135deg, #409eff, #667eea);
  box-shadow: 0 5px 12px rgba(64, 158, 255, 0.24);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.manual-dialog-title {
  color: #263445;
  font-size: 17px;
  font-weight: 600;
  line-height: 1.4;
}

.manual-dialog-subtitle {
  margin-top: 2px;
  color: #9099a6;
  font-size: 12px;
  line-height: 1.4;
}

.manual-dialog-count {
  padding: 6px 12px;
  border: 1px solid #d9eaff;
  border-radius: 16px;
  background: #f1f7ff;
  color: #337ecc;
  font-size: 12px;
  font-weight: 600;
}

.manual-dialog-body {
  max-height: 68vh;
  overflow-y: auto;
  padding: 0 4px 4px 0;
}

.manual-playlet-tip {
  margin-bottom: 20px;
  border: 1px solid #dcecff;
  border-radius: 10px;
}

.manual-section {
  margin-bottom: 20px;
}

.manual-section-heading {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 14px;
  color: #344256;
  font-size: 14px;
  font-weight: 600;
}

.section-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  border-radius: 7px;
  background: #edf5ff;
  color: #409eff;
  font-size: 11px;
  font-weight: 700;
}

.section-line {
  height: 1px;
  flex: 1;
  background: #edf0f5;
}

.section-heading-tip {
  color: #a0a7b2;
  font-size: 11px;
  font-weight: 400;
}

.selected-drama-card {
  padding: 13px 15px;
  border: 1px solid #e8edf5;
  border-radius: 10px;
  background: #fafcff;
}

.selected-drama-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #596579;
  font-size: 12px;
  font-weight: 600;
}

.selected-drama-count {
  color: #8b96a6;
  font-weight: 400;
}

.manual-playlet-form {
  padding: 0 4px 0 2px;
}

.manual-playlet-form :deep(.el-form-item) {
  margin-bottom: 14px;
}

.manual-playlet-form :deep(.el-form-item__label) {
  color: #596579;
  font-weight: 500;
}

.manual-playlet-form :deep(.el-form-item__content) {
  min-width: 0;
}

.parameter-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  padding: 14px 14px 0;
  border: 1px solid #e8edf5;
  border-radius: 10px;
  background: #fafcff;
}

.parameter-grid :deep(.el-form-item) {
  display: block;
  margin-bottom: 12px;
}

.parameter-grid :deep(.el-form-item__label) {
  display: block;
  float: none;
  width: auto !important;
  padding: 0 0 6px;
  line-height: 20px;
  text-align: left;
}

.parameter-grid :deep(.el-form-item__content) {
  margin-left: 0 !important;
}

.selected-drama-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-height: 120px;
  overflow-y: auto;
}

.selected-drama-tag {
  max-width: 100%;
  border-radius: 6px;
}

.selected-drama-empty {
  font-size: 13px;
  color: #909399;
}

.manual-dialog-footer {
  justify-content: space-between;
  width: 100%;
}

.manual-footer-tip {
  color: #a0a7b2;
  font-size: 12px;
}

.account-select-box {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.account-select-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  background: #fff;
}

.account-names {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #303133;
}

.account-count {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

.account-placeholder {
  font-size: 13px;
  color: #a8abb2;
}

.douyin-assignment {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.account-cell-name {
  color: #303133;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-cell-id {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
}

.num-blue {
  color: #409eff;
  font-weight: 600;
}

.roi-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-tip {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.budget-field {
  display: flex;
  align-items: center;
  gap: 8px;
}

.budget-unit {
  font-size: 14px;
  color: #303133;
}

// 手动铺剧提交结果
.skipped-box {
  margin-top: 14px;
  padding: 12px 14px;
  background: #fdf6ec;
  border: 1px solid #faecd8;
  border-radius: 6px;
}

.skipped-title {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #e6a23c;
}

.skipped-item {
  font-size: 12px;
  line-height: 1.7;
  color: #606266;
  word-break: break-all;
}

// 铺剧日志操作列 / 详情
.danger-text {
  color: #f56c6c;
}

.success-text {
  color: #67c23a;
}

.fail-text {
  color: #f56c6c;
}

.waiting-text {
  color: #e6a23c;
}

.log-detail-box {
  max-height: 70vh;
  overflow: auto;
}

.detail-descriptions {
  margin-bottom: 14px;
}

.detail-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 18px;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: #f7f8fa;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
}

.detail-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.detail-toolbar-tip {
  font-size: 12px;
  color: #909399;
}

.detail-section-title {
  margin: 16px 0 10px;
  padding-left: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  line-height: 1;
  border-left: 3px solid #409eff;
}

:deep(.el-dialog.manual-playlet-dialog) {
  overflow: hidden;
  border-radius: 16px;
  box-shadow: 0 18px 55px rgba(32, 54, 86, 0.2);
}

:deep(.el-dialog.manual-playlet-dialog .el-dialog__header) {
  margin-right: 0;
  padding: 18px 20px 16px;
  border-bottom: 1px solid #eef2f7;
}

.manual-playlet-dialog :deep(.el-dialog__body) {
  padding: 20px 24px 8px;
}

.manual-playlet-dialog :deep(.el-dialog__footer) {
  padding: 14px 24px 18px;
  border-top: 1px solid #eef2f7;
}

.manual-playlet-dialog :deep(.el-dialog__headerbtn) {
  top: 20px;
  right: 18px;
}

.manual-playlet-dialog :deep(.el-input__inner),
.manual-playlet-dialog :deep(.el-select .el-input__inner),
.manual-playlet-dialog :deep(.el-input-number .el-input__inner) {
  border-radius: 8px !important;
}

.manual-playlet-dialog :deep(.el-button) {
  border-radius: 8px;
}

.manual-playlet-dialog :deep(.el-radio-button:first-child .el-radio-button__inner),
.manual-playlet-dialog :deep(.el-radio-button:last-child .el-radio-button__inner) {
  border-radius: 8px;
}

.manual-playlet-dialog :deep(.el-radio-button:first-child .el-radio-button__inner) {
  border-left: 1px solid #dcdfe6;
}

.manual-playlet-dialog :deep(.el-alert__title) {
  font-size: 13px;
}

:deep(.el-input__inner),
:deep(.el-select .el-input__inner) {
  border-radius: 12px !important;
}

:deep(.el-table) {
  border-radius: 14px;
  overflow: hidden;
}

:deep(.el-table th.el-table__cell) {
  background-color: #f4f7fc !important;
}
</style>
